<template>
  <mp-box>
    <mp-box
      bg="white"
      :p="noPadding ? 0 : 6"
      :min-h="hasTab ? $contentHeightTab : $contentHeight"
      border-left="1px"
      border-top="1px"
      border-left-color="gray.100"
      border-top-color="gray.100"
      border-top-left-radius="md"
    >
      <slot name="content" />
    </mp-box>
  </mp-box>
</template>
<script>
export default {
  name: 'ContentWrapper',
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    hasTab: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
